import React, { useState } from 'react'
import SinglePageSurvey from './components/SinglePageSurvey'
import SectionWiseSurvey from './components/SectionWiseSurvey'

// import * as Yup from 'yup';

export default function QNA() {
    //States
    const [surveyUI, setSurveyUI] = useState(1)

    return (
        <>
            {surveyUI === 0 && <SinglePageSurvey />}
            {surveyUI === 1 && <SectionWiseSurvey />}
        </>
    )
}
